module.exports = "/images/Close-black.svg?0ff33883c421440367912d9809f123d2";